'use strict';
import { default as LabelViewerRoute } from './labelViewer/labelViewer.routes';
import { default as ClassifierRoute } from './classifier/classifier.routes';
import { default as EntityRecommenderRoute } from './entityRecommender/entityRecommender.routes';

module.exports = {
  LabelViewerRoute,
  ClassifierRoute,
  EntityRecommenderRoute
};



// WEBPACK FOOTER //
// ./src/components/app.routes.js